import TextArea from 'components/Input/Textarea';
import Modal from 'components/Modal';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import service from 'services';
import actions from 'state/actions';
import selectors from 'state/selectors';
import AppHelpers from 'utils/helpers/app.helpers';
import IntlHelper from 'utils/helpers/intl.helper';

const Memo = () => {
  const [value, setValue] = useState('');
  const userCode = useSelector(selectors.user.getIdUser);
  const protocols = useSelector(selectors.documents.selectAllActiveDocumentsID);
  const document = useSelector(selectors.documents.selectActiveDocument);
  const dispatch = useDispatch();
  const t = IntlHelper.useTranslator();

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { value } = e.target;
    setValue(value);
  };

  const onSave = async () => {
    if (userCode) {
      try {
        await service.setMemo({ protocols, idUser: userCode, memo: value });
        dispatch(actions.documents.updateTableRows({ protocols, property: 'memo', value }));
        AppHelpers.notify('success', t('saved-memo'));
      } catch (err) {
        console.error('err-memo', err);
      }
      dispatch(actions.modal.closeModal());
    }
  };

  const setValueFunction = () => {
    protocols.length === 1 && document && setValue(document.memo);
  };

  const stableSetValueFunction = useCallback(setValueFunction, []);

  useEffect(() => {
    stableSetValueFunction();
  }, [stableSetValueFunction]);

  return (
    <>
      <Modal.Header title={t('Notes')} subtitle={t('subtitle-for-notes')} />
      <Modal.Content>
        <TextArea onChange={handleChange} value={value} />
      </Modal.Content>
      <Modal.Footer confirmText={t('save-memo')} confirmAction={onSave} />
    </>
  );
};

export default Memo;
